var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 8,
    viewBox: "0 0 18 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DIN"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.30963 0.515006C4.04296 0.515006 4.6863 0.658339 5.23963 0.945005C5.79963 1.23167 6.22963 1.64167 6.52963 2.17501C6.8363 2.70167 6.98963 3.31501 6.98963 4.01501C6.98963 4.71501 6.8363 5.32834 6.52963 5.85501C6.22963 6.37501 5.79963 6.77834 5.23963 7.06501C4.6863 7.35167 4.04296 7.49501 3.30963 7.49501H0.869629V0.515006H3.30963ZM3.25963 6.30501C3.99296 6.30501 4.55963 6.10501 4.95963 5.70501C5.35963 5.30501 5.55963 4.74167 5.55963 4.01501C5.55963 3.28834 5.35963 2.72167 4.95963 2.31501C4.55963 1.90167 3.99296 1.69501 3.25963 1.69501H2.26963V6.30501H3.25963Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6076 0.515006V7.49501H8.2076V0.515006H9.6076Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1308 7.49501H15.7308L12.5608 2.70501V7.49501H11.1608V0.505005H12.5608L15.7308 5.30501V0.505005H17.1308V7.49501Z",
    fill: "black",
    fillOpacity: 0.87
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDin);
export default __webpack_public_path__ + "static/media/DIN.90f2e616061ad686a1393aaaa0e05be5.svg";
export { ForwardRef as ReactComponent };